import { SavedViewMetaData } from 'modules/messagingInsights/types';
import { useGetCurrSettings } from './useGetCurrSettings';

/**
 * Compiles the full view payload which can then be passed to the backend when
 * creating or updating views.  The view settings will reflect the all settings currently
 * displayed in the UI (aka all applied filters if MIApplyButton is on), and the
 * metaData param holds any updates a user makes to a view's properties (i.e. name, description,
 * default tab, etc.).
 * @param metaData an object mapping all view properties to their values
 */
export const useGetViewPayload = (metaData: Partial<SavedViewMetaData> & { tab: string }) => {
  const currViewSettings = useGetCurrSettings();

  const reqPayload = {
    name: metaData.name,
    description: metaData.description,
    isPrivate: metaData.isPrivate,
    defaultTab: metaData.tab,
    settings: currViewSettings,
  };

  return reqPayload;
};
